import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, OrderByDirection } from 'firebase/firestore';
import { db } from '../firebase';

interface OrderByOptions {
    field: string;
    direction?: OrderByDirection;
}

export const useCollection = <T extends { id: string }>(collectionName: string, orderByOptions?: OrderByOptions) => {
    const [data, setData] = useState<T[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const collectionRef = collection(db, collectionName);
                const q = orderByOptions 
                    ? query(collectionRef, orderBy(orderByOptions.field, orderByOptions.direction))
                    : query(collectionRef);

                const snapshot = await getDocs(q);
                const fetchedData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as T));
                setData(fetchedData);
            } catch (err) {
                setError(err as Error);
                console.error(`Error fetching collection ${collectionName}:`, err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [collectionName, orderByOptions?.field, orderByOptions?.direction]);

    return { data, isLoading, error, setData };
};
